// apps/web/src/components/parties/PartyManager.tsx
// Party registry management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Party } from '../../types/platform.js';

export function PartyManager() {
  return (
    <ManagerPage
      title="Parties"
      listPath="/api/v1/parties"
      listKey="parties"
      createLabel="New Party"
      className="parties-manager"
      renderItem={(raw) => {
        const p = raw as Party;
        return (
          <div className="manager-card" key={p.id}>
            <h3>{p.displayName}</h3>
            <p className="status-badge">{p.partyType}</p>
            <p>Status {p.status}</p>
            <div className="actions">
              <button className="btn btn-secondary">View</button>
              <button className="btn btn-primary">Payment Accounts</button>
            </div>
          </div>
        );
      }}
    />
  );
}